export const calculatePercentage = (count: number, total: number): string => {
    return `${((count/total || 0) * 100).toFixed(0)}%`;
};